import React from 'react';

import { useAuth } from 'context/Auth';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';

import { FACHINTERESSENT_ACCESS_DENIED_MESSAGE } from 'global/constants';

import { logoutWithRedirect } from 'utils/AuthUtils';

export const FachinteressentAccessDeniedModal = () => {
  const { isCIAM } = useAuth();

  return (
    <CustomModal
      isOpen
      title="Zugriff verweigert"
      content={<div>{FACHINTERESSENT_ACCESS_DENIED_MESSAGE}</div>}
      ctaButtons={
        <ActionButton
          inverted
          onClick={() => {
            logoutWithRedirect(isCIAM);
          }}
          title="Zurück zum Login"
        />
      }
    />
  );
};
